import {Component, HostListener, Inject, ApplicationRef, NgZone} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DOCUMENT} from '@angular/common';

import {StateService} from './shared/state/state.service';
import {AuthService} from './auth/auth.service';
import {ga} from '../declarations/ga';
import {AppUpdatesService} from './shared/app-updates/app-updates.service';
import { FlagService } from './shared/flag/flag.service';
import { AppStabilityService } from './shared/app-stability.service';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';

/**
 * Main component. Set translation and authentication.
 */
@Component({
  selector: 'qm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  private tenant: number;

  /**
   * Default constructor. Initialize translations and authentication
   * @param {TranslateService} translate
   * @param stateService
   * @param document
   */
  constructor(
    translate: TranslateService,
    private stateService: StateService,
    private authService: AuthService,
    private flag: FlagService,
    @Inject(DOCUMENT) private document: Document,
    private appUpdateService: AppUpdatesService,
    appStability: AppStabilityService,
    private ngZone: NgZone,
    private tooltipConfigService: NgbTooltipConfig,
  ) {
    this.tooltipConfigService.container = 'body';
    if (localStorage.getItem('enable-console') !== 'true') {
      console.log('Production mode enabled, disabling console.log');
      window.console.log = function () {
      };
    }
    if (this.stateService.getPartOfState('settingsState')) {
      const settings = this.stateService.getPartOfState('settingsState');
      if (settings.screenMode === 0) {
        if (settings.fontSize === 'Small') {
          document.body.style.fontSize = '75%';
        } else if (settings.fontSize === 'Normal') {
          document.body.style.fontSize = '100%';
        } else if (settings.fontSize === 'Big') {
          document.body.style.fontSize = '125%';
        } else if (settings.fontSize === 'Large') {
          document.body.style.fontSize = '150%';
        } else {
          document.body.style.fontSize = '200%';
        }
      } else {
        document.body.style.fontSize = '170%';
      }
    }

    try {
      const temp = this.stateService.getPartOfState('settingsState');
      console.log(temp);
      // Set empty object for english translations.
      // English is used in the UI code so we don't need a specific object of english translations.
      // Translator will return the given string(key) because english translation object is empty
      translate.setTranslation('en', {});
      // English will be used as a fallback when a translation isn't found in the current language.
      translate.setDefaultLang('en');
      if (temp.language) {
        translate.use(temp.language.toLowerCase());
      } else {
        // Set finnish language if language was not defined in the local storage
        translate.use('fi');
        temp.language = 'fi';
        this.stateService.updateState('settingsState', temp);
      }
      console.log(translate.currentLang);
    } catch (e) {
      console.warn(e);
    }

    appStability.whenFirstStable().then(() => {
      console.log('App is stable, starting update monitor');
      this.appUpdateService.startUpdateMonitor();
    });

    // prevent issues with overflow:hidden
    tooltipConfigService.container = 'body';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target: HTMLElement = event.target as HTMLElement;
    if (!this.tenant) {
      this.tenant = this.authService.getTenant();
    }
    // console.log('Document clicked');
    // console.log(event);
    try {
      let targetID: string;
      if (target.tagName === 'BUTTON' || target.tagName === 'A') {
        console.log('Target was link or button');
        targetID = target.dataset.btnid;
      } else {
        let parent: HTMLElement = target.parentNode as HTMLElement;
        while (parent) {
          if (parent.tagName === 'BUTTON' || parent.tagName === 'A') {
            console.log('Target parent was link or button');
            targetID = parent.dataset.btnid;
            break;
          } else {
            parent = parent.parentNode as HTMLElement;
          }
        }
      }
      if (targetID) {
        console.log('Click target was', targetID);
        ga('send', {
          hitType: 'event',
          eventCategory: 'Action click for tenant ' + this.tenant,
          eventAction: targetID,
          eventLabel: targetID,
        });

      }
    } catch (e) {
    }
  }
}
